import { render, staticRenderFns } from "./u-tit-wrap-underline.vue?vue&type=template&id=5f1863ba&scoped=true&"
import script from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-wrap-underline.vue?vue&type=style&index=0&id=5f1863ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1863ba",
  null
  
)

export default component.exports